// Numbers, money and dates the way the team reads them: Indian grouping, IST, "3 h ago".

type N = number | null | undefined;
type S = string | null | undefined;

export const inr = (v: N, d = 0) => v == null ? "—" : "₹" + Number(v).toLocaleString("en-IN", { maximumFractionDigits: d, minimumFractionDigits: d });
export const lakh = (v: N) => v == null ? "—" : Math.abs(v) >= 100000 ? "₹" + (v / 100000).toFixed(2) + " L" : inr(v);
export const num = (v: N) => v == null ? "—" : Number(v).toLocaleString("en-IN");
export const pct = (v: N) => v == null ? "—" : v + "%";
export const dt = (s: S) => !s ? "—" : new Date(s).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" });
export const day = (s: S) => !s ? "—" : new Date(s).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "2-digit", timeZone: "Asia/Kolkata" });
export function ago(s: S) {
  if (!s) return "never";
  const m = (Date.now() - new Date(s).getTime()) / 60000;
  if (m < 60) return Math.max(1, Math.round(m)) + " min ago";
  if (m < 1440) return Math.round(m / 60) + " h ago";
  return Math.round(m / 1440) + " d ago";
}
export const dur = (s: N) => `${Math.floor((s || 0) / 60)}m ${String((s || 0) % 60).padStart(2, "0")}s`;
export const fmtMin = (n: N) => { const x = n || 0; return x >= 60 ? `${Math.floor(x / 60)} h ${x % 60} m` : `${x} min`; };
/** Chart labels: 1.2L, 45k. */
export const short = (v: number) => v >= 100000 ? (v / 100000).toFixed(1) + "L" : v >= 1000 ? (v / 1000).toFixed(0) + "k" : String(Math.round(v));

export function fmtPhone(p: S) {
  const d = String(p || "").replace(/\D/g, "");
  if (d.length < 10) return p || "";
  const t = d.slice(-10);
  return `+91 ${t.slice(0, 5)} ${t.slice(5)}`;
}
export const plural = (n: number, one: string, many?: string) => `${num(n)} ${n === 1 ? one : many || one + "s"}`;
export function clock(s: N) {
  const x = Math.max(0, s || 0), h = Math.floor(x / 3600), m = Math.floor((x % 3600) / 60), sec = x % 60;
  return h ? `${h}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}` : `${m}:${String(sec).padStart(2, "0")}`;
}
/** The wall-clock time in IST, as a Date whose local fields read IST. */
export const istDate = (s: string | Date) => new Date(new Date(s).toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
export const timeOf = (s: string) => new Date(s).toLocaleTimeString("en-IN", { hour: "numeric", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata" }).replace(" ", " ").toLowerCase();
export function dayLabel(s: string) {
  const d = istDate(s), now = istDate(new Date());
  const y = new Date(now);
  y.setDate(now.getDate() - 1);
  if (d.toDateString() === now.toDateString()) return "Today";
  if (d.toDateString() === y.toDateString()) return "Yesterday";
  return d.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short", ...(d.getFullYear() !== now.getFullYear() ? { year: "numeric" } : {}) });
}
/** Today at `hour`:00 IST, as an ISO string. */
export function istToday(hour: number) {
  const IST = 330 * 60e3;
  const d = new Date(Date.now() + IST);
  d.setUTCHours(hour, 0, 0, 0);
  return new Date(d.getTime() - IST).toISOString();
}
export const whenShort = (s: string) => { const l = dayLabel(s); return (l === "Today" ? "" : l + ", ") + timeOf(s); };
/** "2026-09" for the current month in IST. */
export const istMonth = () => new Date(Date.now() + 5.5 * 3600e3).toISOString().slice(0, 7);
